export default __webpack_public_path__ + "static/media/Inter-Bold.1f24ea5f.ttf";